let slideIndex = 1

function initCarousel() {
  const carousel = document.querySelector('.carousel')

  if (carousel !== null) {
    showSlides(slideIndex)

    // setInterval(() => {
    //   nextSlide(1)
    // }, 5000)
  }
}

function nextSlide(n) {
  showSlides((slideIndex += n))
}

function currentSlide(n) {
  showSlides((slideIndex = n))
}

function showSlides(n) {
  const slides = document.getElementsByClassName('carousel__slide')
  // const dots = document.getElementsByClassName('carousel__dot')

  if (n > slides.length) {
    slideIndex = 1
  }

  if (n < 1) {
    slideIndex = slides.length
  }

  for (let i = 0; i < slides.length; i++) {
    slides[i].style.display = 'none'
  }

  // for (let i = 0; i < dots.length; i++) {
  //   dots[i].className = dots[i].className.replace(' carousel__dot--active', '')
  // }

  slides[slideIndex - 1].style.display = 'grid'
  // dots[slideIndex - 1].className += ' carousel__dot--active'
}

function init() {
  initCarousel()
  window.nextSlide = nextSlide
  window.currentSlide = currentSlide
}

export default init



// WEBPACK FOOTER //
// ./frontend/resources/assets/js/components/ui/global/carousel.js